module.exports = __webpack_public_path__ + "static/media/outside.46d7353d.mp3";